// extracted by mini-css-extract-plugin
module.exports = {"root":"TableRow-root-434778d569f41b708a72528aa8fed4e3","body":"TableRow-body-d6af8cb387d558acfc892e7a203a62dd"};